var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointmentsIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 678.369,
    viewBox: "0 0 800 678.369",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-454.512 -153.556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(472.638 153.556)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(503.941 153.556)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(535.243 153.556)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.238,0H484.773a15.238,15.238,0,0,1,15.238,15.238v117.2a15.238,15.238,0,0,1-15.238,15.238H15.238A15.238,15.238,0,0,1,0,132.44V15.238A15.238,15.238,0,0,1,15.238,0Z",
    transform: "translate(454.843 215.029)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.456,35.46H1.895C.826,35.449-.022,35.014,0,34.488c.022-.51.857-.921,1.894-.932H500.456c1.069.011,1.917.447,1.894.973C502.328,35.038,501.493,35.449,500.456,35.46Z",
    transform: "translate(454.512 147.955)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 109.305,
    height: 105.816,
    rx: 52.908,
    transform: "translate(479.262 304.565)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.037,280.691h40.029a5.584,5.584,0,0,1,5.444,5.714h0a5.584,5.584,0,0,1-5.444,5.714H76.037a5.584,5.584,0,0,1-5.444-5.714h0A5.584,5.584,0,0,1,76.037,280.691Z",
    transform: "translate(437.861 156.435)",
    fill: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8,299.418h91.746a5.584,5.584,0,0,1,5.444,5.714h0a5.584,5.584,0,0,1-5.444,5.714H53.8a5.584,5.584,0,0,1-5.444-5.714h0A5.584,5.584,0,0,1,53.8,299.418Z",
    transform: "translate(434.241 159.484)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8,318.145h91.746a5.584,5.584,0,0,1,5.444,5.714h0a5.584,5.584,0,0,1-5.444,5.714H53.8a5.584,5.584,0,0,1-5.444-5.714h0A5.584,5.584,0,0,1,53.8,318.145Z",
    transform: "translate(434.239 162.533)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.742,605.907H0v-1.429H355.742Z",
    transform: "translate(898.77 226.017)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(956.863 260.794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H26.31l3.462,27.049L0,30.623Z",
    transform: "translate(100.767 72.034)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,127.693a20.811,20.811,0,0,1-.562,4.79L264.72,200.2A17.878,17.878,0,0,1,243.2,213.518l-63.778-19.79-3.114-.962a18.467,18.467,0,0,1-13.99,2.9c-9.257-1.638-15.666-9.171-14.314-16.837s9.952-12.542,19.209-10.914a18.5,18.5,0,0,1,12.161,7.5l.047.009.162.029,55.512,6.867,4.666-56.3a20.754,20.754,0,0,1,41.437,1.667Z",
    transform: "translate(-147.821 -11.069)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.92,127.693a20.811,20.811,0,0,1-.562,4.79L269.3,203.061a17.878,17.878,0,0,1-21.523,13.314L184,198.642l2.857-27.618h0l48.57,6.666,6.057-51.665a20.754,20.754,0,0,1,41.437,1.667Z",
    transform: "translate(-149.545 -11.069)",
    fill: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.139,
    height: 19.139,
    transform: "translate(200.803 499.881) rotate(-36.399)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.069,550.949l-32.746,24.141a23.464,23.464,0,0,1-9.5,4.143l-8.176,1.549a4.5,4.5,0,0,1-4.381-7.207l9.914-12.628,13.05-26.906.075.069c1.886,1.724,4.751,4.318,4.966,4.445,4.03.892,7.125.391,9.2-1.489,3.618-3.279,2.889-9.711,2.881-9.776l-.006-.049.043-.025a3.222,3.222,0,0,1,2.822-.387c1.884.688,2.867,3.16,3.007,3.539,1.839.258,6.621,5.741,7.006,6.185,2.752.5,4.646,1.531,5.63,3.07a6.259,6.259,0,0,1,.5,5.1,11.361,11.361,0,0,1-4.281,6.228Z",
    transform: "translate(-156.803 -31.068)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.139,
    height: 19.139,
    transform: "translate(64.964 533.475)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.658,603.19H188.976a23.464,23.464,0,0,1-10.105-2.3l-7.5-3.605a4.5,4.5,0,0,1,.75-8.4l15.473-4.281,26.47-13.913.02.1c.5,2.507,1.262,6.295,1.36,6.524,2.715,3.11,5.5,4.543,8.288,4.26,4.858-.493,8.088-6.1,8.12-6.159l.025-.043.05.005a3.222,3.222,0,0,1,2.5,1.364c1.108,1.671.432,4.245.321,4.633,1.327,1.3,1.923,8.55,1.969,9.136,1.919,2.034,2.831,3.99,2.71,5.812a6.259,6.259,0,0,1-2.626,4.4,11.361,11.361,0,0,1-7.142,2.473Z",
    transform: "translate(-148.821 -33.167)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.81,252.291H221.084l-14.621,304.3h32.3l20.871-138.317,83.749,110.654,30.575-27.663-61.151-82.99Z",
    transform: "translate(-150.615 -17.994)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.49,208.489l14.981,44.146-84.759-.952,12.637-40.337Z",
    transform: "translate(-151.437 -15.906)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.285,90.835,247.7,103.9,212.164,287.348l73.121,8.927,5.332-27.969,5.083,27.969h25.329L293.721,113.852a60.88,60.88,0,0,0-8.436-23.017h0Z",
    transform: "translate(-150.887 -10.299)",
    fill: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.719,315.639l.654-30.153-17.605-.382-.654,30.153a18.483,18.483,0,0,0-5.57,13.159c-.2,9.4,5.937,17.155,13.715,17.324s14.25-7.314,14.454-16.713A18.483,18.483,0,0,0,276.719,315.639Z",
    transform: "translate(-152.859 -19.557)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.357,158.7V304.852h30.575l9.036-144.921",
    transform: "translate(-152.802 -13.533)",
    fill: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.208,
    cy: 30.208,
    r: 30.208,
    transform: "translate(107.683 94.729) rotate(-135)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.341,147.975l1.464-2.947-7.369-3.661s-8.129-13.227-22.839-9.51S395.27,137.8,395.27,137.8l-7.35,3.7,3.689,3.67-6.618,2.225,4.421,2.2-5.144,2.957,2.769,15.157s4.6-11.5,13.442-7.1,25.017-2.271,25.017-2.271l14.052,27.195s2.9-9.533,8.068-6.991C447.616,178.532,460.82,157.5,445.341,147.975Z",
    transform: "translate(-309.245 -120.115)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(746.413 351.692)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 86,
    rx: 8,
    transform: "translate(0.1 -0.038)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714,1.428A4.29,4.29,0,0,0,1.428,5.714V79.991a4.29,4.29,0,0,0,4.285,4.285H222.831a4.29,4.29,0,0,0,4.285-4.285V5.714a4.29,4.29,0,0,0-4.285-4.285H5.714M5.714,0H222.831a5.714,5.714,0,0,1,5.714,5.714V79.991a5.714,5.714,0,0,1-5.714,5.714H5.714A5.714,5.714,0,0,1,0,79.991V5.714A5.714,5.714,0,0,1,5.714,0Z",
    transform: "translate(0 0)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.427,0A11.427,11.427,0,1,1,0,11.427,11.427,11.427,0,0,1,11.427,0Z",
    transform: "translate(17.141 12.856)",
    fill: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714,0H165.695a5.714,5.714,0,1,1,0,11.427H5.714A5.714,5.714,0,0,1,5.714,0Z",
    transform: "translate(17.141 44.28)",
    fill: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714,0H79.991a5.714,5.714,0,1,1,0,11.427H5.714A5.714,5.714,0,0,1,5.714,0Z",
    transform: "translate(17.141 61.421)",
    fill: "#1a1a1b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(670.225 459.307)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 86,
    rx: 8,
    transform: "translate(0.287 0.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714,1.428A4.29,4.29,0,0,0,1.428,5.714V79.991a4.29,4.29,0,0,0,4.285,4.285H222.831a4.29,4.29,0,0,0,4.285-4.285V5.714a4.29,4.29,0,0,0-4.285-4.285H5.714M5.714,0H222.831a5.714,5.714,0,0,1,5.714,5.714V79.991a5.714,5.714,0,0,1-5.714,5.714H5.714A5.714,5.714,0,0,1,0,79.991V5.714A5.714,5.714,0,0,1,5.714,0Z",
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.427,0A11.427,11.427,0,1,1,0,11.427,11.427,11.427,0,0,1,11.427,0Z",
    transform: "translate(17.141 12.856)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714,0H165.695a5.714,5.714,0,1,1,0,11.427H5.714A5.714,5.714,0,0,1,5.714,0Z",
    transform: "translate(17.141 44.28)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714,0H79.991a5.714,5.714,0,1,1,0,11.427H5.714A5.714,5.714,0,0,1,5.714,0Z",
    transform: "translate(17.141 61.421)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(670.225 560.256)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 85,
    rx: 8,
    transform: "translate(0.287 0.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714,1.428A4.29,4.29,0,0,0,1.428,5.714V79.991a4.29,4.29,0,0,0,4.285,4.285H222.831a4.29,4.29,0,0,0,4.285-4.285V5.714a4.29,4.29,0,0,0-4.285-4.285H5.714M5.714,0H222.831a5.714,5.714,0,0,1,5.714,5.714V79.991a5.714,5.714,0,0,1-5.714,5.714H5.714A5.714,5.714,0,0,1,0,79.991V5.714A5.714,5.714,0,0,1,5.714,0Z",
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.427,0A11.427,11.427,0,1,1,0,11.427,11.427,11.427,0,0,1,11.427,0Z",
    transform: "translate(17.141 12.856)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714,0H165.695a5.714,5.714,0,1,1,0,11.427H5.714A5.714,5.714,0,0,1,5.714,0Z",
    transform: "translate(17.141 44.28)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714,0H79.991a5.714,5.714,0,1,1,0,11.427H5.714A5.714,5.714,0,0,1,5.714,0Z",
    transform: "translate(17.141 61.421)",
    fill: "#e6e6e6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsIllustration);
export default __webpack_public_path__ + "static/media/appointments-illustration.1c1f0e2adb895fc63297a5055241f4bb.svg";
export { ForwardRef as ReactComponent };